__turbopack_context__.v({
  "action": "note-panel-module__IEATNG__action",
  "italic": "note-panel-module__IEATNG__italic",
  "label": "note-panel-module__IEATNG__label",
  "panel": "note-panel-module__IEATNG__panel",
  "text": "note-panel-module__IEATNG__text",
  "toneDanger": "note-panel-module__IEATNG__toneDanger",
  "toneWarn": "note-panel-module__IEATNG__toneWarn",
});
